import { getSelectedFilters } from './filter';
import { BOOKING } from '../constants';

/**
 * Resolves which promo subject to use for discount display from URL filters.
 * Only dedicated solo spots (soloType filter) count as 'solo'; any cabin selection —
 * including "Double Cabin for Solo" (the *Solo cabinType values) — is 'cabin'.
 */
export const getPromoBookingSubjectFromLocation = location => {
  const { soloType, cabinType, cabinBookingType } = getSelectedFilters(location);
  if (!cabinBookingType) {
    return BOOKING.YACHT_SUBJECT;
  }
  if ((cabinType || []).length > 0) {
    return BOOKING.CABIN_SUBJECT;
  }
  if ((soloType || []).length > 0) {
    return BOOKING.SOLO_SUBJECT;
  }
  return BOOKING.CABIN_SUBJECT;
};

/**
 * @param {string[]} enabledSubjects
 * @param {string} subject yacht|cabin|solo
 */
export const discountMatchesEnabledSubject = (enabledSubjects, subject) => {
  if (!enabledSubjects?.length) {
    return true;
  }
  if (subject === BOOKING.YACHT_SUBJECT) {
    return enabledSubjects.includes(BOOKING.YACHT_SUBJECT);
  }
  if (subject === BOOKING.SOLO_SUBJECT) {
    return enabledSubjects.includes(BOOKING.SOLO_SUBJECT);
  }
  if (subject === BOOKING.CABIN_SUBJECT) {
    return enabledSubjects.includes(BOOKING.CABIN_SUBJECT);
  }
  return enabledSubjects.includes(subject);
};

/** Best automatic discount when cabin vs solo is not yet chosen (browse / calendar). */
export const getBestCabinPromoDiscount = (getDiscountForWeekAndSubject, weekId, packageId) => {
  const cabinDiscount = getDiscountForWeekAndSubject(weekId, BOOKING.CABIN_SUBJECT, packageId);
  const soloDiscount = getDiscountForWeekAndSubject(weekId, BOOKING.SOLO_SUBJECT, packageId);
  if (!cabinDiscount) {
    return soloDiscount;
  }
  if (!soloDiscount) {
    return cabinDiscount;
  }
  return (cabinDiscount.discountPercentage || 0) >= (soloDiscount.discountPercentage || 0) ? cabinDiscount : soloDiscount;
};
